import React from "react";
import Challenge from "./Challenge";

const hintRowCount = 60;
const hintColumnCount = 30;

export default props => (
  <Challenge
    rowCount={hintRowCount}
    columnCount={hintColumnCount}
    hintElement="DIAMOND"
    titleText="solve"
    acceptedRune="diamond"
    {...props}
  />
);



// WEBPACK FOOTER //
// ./src/components/challenges/DiamondChallenge.js